import http from "../../services/http";

const getAllGroupsApi = async (form_id) => {
  return await http("get", `v1/formularios_colaboradores/grupos/getAll/${form_id}`);
};

const getGroupByIdApi = async (id) => {
  return await http("get", `v1/formularios_colaboradores/grupos/get/${id}`);
};

const createGroupApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/grupos/create", data);
};

const updateGroupApi = async (data) => {
  return await http("post", "v1/formularios_colaboradores/grupos/update", data);
};

const deleteGroupApi = async (id) => {
  return await http("post", "v1/formularios_colaboradores/grupos/delete", { id: id });
};

export { deleteGroupApi, updateGroupApi, createGroupApi, getGroupByIdApi, getAllGroupsApi };
